module.exports = __webpack_public_path__ + "img/tuyau_l.7a12fac4.svg";